import { makeStyles, withStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  img: {
    width: '100%',
    borderRadius: 5,
  },
}))

export default useStyles
